<div class="chat-sidebar" [class.open]="isOpen">
  <div class="chat-sidebar-header">
    <button *ngIf="showChatBox" class="back-btn" (click)="backToList()">
      <i class="mdi mdi-arrow-left"></i>
    </button>
    <h5>{{ showChatBox ? 'Chat' : 'Staff and Admin chats' }}</h5>
    <button class="close-btn" (click)="closeSidebar()">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
  <div class="chat-sidebar-body">
    <perfect-scrollbar style="height: calc(100vh - 60px);" *ngIf="!showChatBox">
      <div class="user-list">
        <div *ngFor="let staff of staffList" class="user-item" (click)="selectStaff(staff)" [class.has-unseen]="staff.conversation_id && (staff.unseen === true || staff.seen === false)">
          <div class="user-avatar">
            <img [src]="getStaffImage(staff)" [alt]="staff.first_name" />
          </div>
          <div class="user-info">
            <h6>{{ staff.first_name }} {{ staff.last_name }}</h6>
            <p>{{ staff.email }}</p>
            <p class="last-message-time" *ngIf="staff.last_message_at">
              <i class="mdi mdi-clock-outline"></i> {{ staff.last_message_at }}
            </p>
          </div>
          <div class="user-badges">
            <span class="unread-badge" *ngIf="staff.conversation_id && staff.unread_count > 0">
              {{ staff.unread_count }}
            </span>
          </div>
        </div>
        <div *ngIf="!staffList || staffList.length === 0" class="no-users">
          <p>No suppliers found</p>
        </div>
      </div>
    </perfect-scrollbar>

    <div class="chat-box" *ngIf="showChatBox">
      <div class="messages-container">
        <div *ngIf="loadingMessages" class="loading-messages">
          <p>Loading messages...</p>
        </div>
        <div *ngIf="!loadingMessages && messages.length === 0" class="no-messages">
          <p>No messages yet.</p>
        </div>
        <perfect-scrollbar *ngIf="!loadingMessages && messages.length > 0" style="height: 100%; width: 100%;">
          <div class="message-list">
            <ng-container *ngFor="let msg of messages">
              <div class="subject-divider" *ngIf="msg.subject">
                <span>{{ msg.subject }}</span>
              </div>
              <div class="message-item" [class.sent]="msg.sender === 'staff'">
                <div class="message-content">
                  <p class="sender-name">
                    {{ msg.sender_name }}
                  </p>
                  <p class="message-text">{{ msg.message }}</p>
                  <span class="message-time">{{ msg.sent_at | date: 'short' }}</span>
                </div>
              </div>
            </ng-container>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</div>
<div class="chat-sidebar-overlay" *ngIf="isOpen" (click)="closeSidebar()"></div>
